import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24c8c187"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scene-industry-library" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import appStore from '@/store';
import { formatter } from '@/utils/';
import { sceneManagePage } from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'i-price-list',
  setup(__props) {

const router = useRouter();
const xrkTableRef = ref();
// IAS 工业端：当前企业信息（industryId = finalDepId）
const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

// 搜索项
const searchConfig: XrkTableProps['searchConfig'] = {
  searchBtn: {
    show: false,
    text: '搜索'
  },
  resetBtn: {
    show: false,
    text: '重置'
  },
  searchColumns: [],
  otherComponents: [
    {
      render() {
        return (
          // style="margin-bottom:15px" 解决没有搜索条件后，搜索容器塌陷
          <BaseButton
            type="primary2"
            style="margin-bottom:15px"
            onClick={() => {
              const [row] = xrkTableRef.value.getTableData()?.value || [];
              // IAS 工业，只会有一条数据，如果新建时列表有数据，那么携带row.planId进入编辑
              router.push({
                path: '/main/i/scene-mgmt/i-price-config',
                ...(row && {
                  query: {
                    planId: row.planId
                  }
                })
              });
            }}
          >
            新增
          </BaseButton>
        );
      }
    }
  ]
};

// 列表
const tableConfig: XrkTableProps['tableConfig'] = {
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号',
      width: 80
    }),
    useTableColumn({
      label: '工业名称',
      prop: 'industryName',
      minWidth: 260
    }),
    useTableColumn({
      label: '已开通场景数',
      prop: 'sceneCount',
      align: 'right'
    }),
    useTableColumn({
      label: '最近更新时间',
      prop: 'updateDt',
      minWidth: 180,
      formatter: ({ cellValue }) => formatter.date(cellValue)
    }),
    useTableColumn({
      label: '操作',
      prop: 'handle',
      fixed: 'right',
      width: 120,
      render: ({ row: _row }) => {
        return (
          <BaseButton
            link
            type="primary2"
            onClick={() => {
              // IAS 工业端：industryId 从 store 取；编辑必须带 planId（V2 detail 无 planId 不返回历史，无参进入恒新建态）
              router.push({
                path: '/main/i/scene-mgmt/i-price-config',
                query: {
                  planId: String((_row as any).planId)
                }
              });
            }}
          >
            配置价格
          </BaseButton>
        );
      }
    })
  ] as any[]
};

const getListAjax = async (params: Record<string, any>) => {
  // IAS 工业端：自动带当前企业信息（industryId = finalDepId），source=3（工业）
  const info = (userInfo.value as any) || {};
  return await sceneManagePage({
    planScope: 1,
    source: 3,
    industryId: info.finalDepId,
    aspId: params.aspId,
    pageNum: params.pageNum,
    pageSize: params.pageSize,
    updateDtStart: params.updateDtStart,
    updateDtEnd: params.updateDtEnd
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref_key: "xrkTableRef",
      ref: xrkTableRef,
      getListAjax: getListAjax,
      searchConfig: searchConfig,
      tableConfig: tableConfig
    }, null, 512)
  ]))
}
}

})